// extracted by mini-css-extract-plugin
module.exports = {"bill-of-lading":"BillOfLading_bill-of-lading__jjiRK","container":"BillOfLading_container__ZDA5I"};